export default {
  tenants: state => state.tenants ? state.tenants : [],
};
